var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{class:'row justify-content-'+(_vm.horizontal ? _vm.horizontal : 'start')+' align-items-'+(_vm.vertical ? _vm.vertical : 'end')},[_vm._t("default",null,{"control":_vm.control})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }